webpackJsonp([9],{

/***/ "+22/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/**
 * Created by LinChengMing on 2017/10/30.
 */

//配置http请求头
__WEBPACK_IMPORTED_MODULE_0_axios___default.a.interceptors.request.use(function (c) {
  var storage = window.localStorage;
  if (storage.hasOwnProperty("token")) {
    c.headers.Authorization = storage.getItem("token");
  }
  return c;
});

/***/ }),

/***/ "+skl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7IBk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('router-view',{attrs:{"name":"sidebar"}}),_vm._v(" "),_c('router-view',{attrs:{"name":"header"}}),_vm._v(" "),_c('router-view',{attrs:{"name":"footer"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7xIN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JHsI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_node_modules_iview_loader_index_js_ref_0_1_App_vue__ = __webpack_require__("eaOS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6accaf60_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_node_modules_iview_loader_index_js_ref_0_1_App_vue__ = __webpack_require__("7IBk");
function injectStyle (ssrContext) {
  __webpack_require__("ramF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_node_modules_iview_loader_index_js_ref_0_1_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6accaf60_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_node_modules_iview_loader_index_js_ref_0_1_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_iview__ = __webpack_require__("BTaQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_iview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_iview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_iview_dist_styles_iview_css__ = __webpack_require__("+skl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_iview_dist_styles_iview_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_iview_dist_styles_iview_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_flyio__ = __webpack_require__("M5Ic");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_flyio___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_flyio__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router_axios_config__ = __webpack_require__("+22/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__baseURL_config__ = __webpack_require__("OKSs");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_normalize_normalize_less__ = __webpack_require__("wSeV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__static_normalize_normalize_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__static_normalize_normalize_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_less_common_less__ = __webpack_require__("JHsI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__static_less_common_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__static_less_common_less__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_icon_iconfont_css__ = __webpack_require__("7xIN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_icon_iconfont_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_icon_iconfont_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_iview___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.baseURL = __WEBPACK_IMPORTED_MODULE_8__baseURL_config__["a" /* default */]; //注册全局接口URl
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$ajax = __WEBPACK_IMPORTED_MODULE_6_axios___default.a;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "OKSs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Created by LinChengMing on 2017/10/27.
 */
//crm 经纪人接口
var crmBroker = {
  //测试环境
  baseUrl: 'https://back.jrerdangjia.com:9862',
  //本地环境
  // baseUrl: 'http://192.168.22.178:9888',
  //经纪人登录
  login: function login() {
    return this.baseUrl + "/broker/login";
  },
  //经纪人注册
  register: function register() {
    return this.baseUrl + "/broker";
  },
  //查询登录经纪人的下属客户
  brokerCustomer: function brokerCustomer() {
    return this.baseUrl + "/wechat/broker/customer";
  },
  products: function products() {
    return this.baseUrl + "/wechat/product";
  },
  addCustomer: function addCustomer() {
    return this.baseUrl + "/broker/customer";
  },
  updateCustomer: function updateCustomer() {
    return this.baseUrl + "/broker/customer/-1";
  },
  getBroker: function getBroker() {
    return this.baseUrl + "/wechat/broker";
  },
  uploadFile: function uploadFile() {
    return this.baseUrl + "/upload/broker/idcard";
  },
  getFile: function getFile(id) {
    return this.baseUrl + "/archive/" + id;
  }

};
/* harmony default export */ __webpack_exports__["a"] = ({
  crmBroker: crmBroker
});

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");



var Header = function Header(resolve) {
  return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("5UT3")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Footer = function Footer(resolve) {
  return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("F71R")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Sidebar = function Sidebar(resolve) {
  return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ANSU")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Login = function Login(resolve) {
  return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("xJsL")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var Register = function Register(resolve) {
  return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("dIqY")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var CustomerInfo = function CustomerInfo(resolve) {
  return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("pkkw")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var AddCustomer = function AddCustomer(resolve) {
  return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("c2zq")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};
var MarketContactor = function MarketContactor(resolve) {
  return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("nJCK")]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  base: '/jr/broker/',
  routes: [{
    path: '/',
    components: {
      default: Login,
      header: Header,
      footer: Footer
    }
  }, {
    path: '/register',
    components: {
      default: Register,
      header: Header,
      footer: Footer
    }
  }, {
    path: '/info',
    components: {
      default: CustomerInfo,
      header: Header,
      sidebar: Sidebar,
      footer: Footer
    }
  }, {
    path: '/add',
    components: {
      default: AddCustomer,
      header: Header,
      sidebar: Sidebar,
      footer: Footer
    }
  }, {
    path: '/market',
    components: {
      default: MarketContactor,
      header: Header,
      sidebar: Sidebar,
      footer: Footer
    }
  }]
}));

/***/ }),

/***/ "eaOS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "ramF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wSeV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.f59a2e3668ff9962d116.js